import {FormUtils} from "../utils/FormUtils";
import {receive} from '../result/ResultActions';
import {finish} from "../steps/StepsActions";
import {OrdersHttpService} from '../http/OrdersHttpService';
import store from '../store';

const paypalErrorCallback = (error) => {
  console.log('On paypal error: ', error);
  paypalFinish(error, null, false);
};

const paypalCancelCallback = () => {
  console.log('On paypal cancel');
};

const paypalConfirmCallback = (result) => {
  console.log('On paypal confirm: ', result);
  paypalFinish(null, result, true);
};

const paypalSucccessCallback = (order) => {
  console.log('On paypal success: ', order);
  paypalFinish(null, order, false);
};

const paypalFinish = (error, result, executeRequired) => {
  if(!result) {
    store.dispatch(receive(error, result, null, null, null, executeRequired, 'paypal'));
    store.dispatch(finish());
  } else {
    OrdersHttpService.getOrder(result.orderId)
      .then(response => {
        store.dispatch(receive(error, result, response, null, null, executeRequired, 'paypal'));
        store.dispatch(finish());
      });
  }
};

const getOptionalParameters = (params) => {
  const result = {};
  result.paypalRecurringBillingAgreement = params.paypalRecurringBillingAgreement;
  result.styles = FormUtils.getValuesByUsage(params.stylesUsage, params.styles);

  if (params.paypalCallbacks) {
    result.errorCallback = paypalErrorCallback;
    result.cancelCallback = paypalCancelCallback;
    result.confirmCallback = paypalConfirmCallback;
    result.successCallback = paypalSucccessCallback;
  }

  return result;
};

const getCallbacksParams = () => {
  return {
    errorCallback: paypalErrorCallback,
    cancelCallback: paypalCancelCallback,
    confirmCallback: paypalConfirmCallback,
    successCallback: paypalSucccessCallback
  }
}

const getResultCallbacksTemplate = () => {
  return `
function resultCallback(error, results) {
  console.log('Error/Result:', error, results);
}

function paypalErrorCallback(error) {
  console.log('On paypal error: ', error);
}

function paypalCancelCallback() {
  console.log('On paypal cancel');
}

function paypalConfirmCallback(orderId) {
  console.log('On paypal confirm: ', orderId);
}

function paypalSucccessCallback(orderId) {
  console.log('On paypal success: ', orderId);
}
    `;
};

const getCallbacksTemplate = () => {
  return `
optionalParameters.paypal.errorCallback = paypalErrorCallback;
optionalParameters.paypal.cancelCallback = paypalCancelCallback;
optionalParameters.paypal.confirmCallback = paypalConfirmCallback;
optionalParameters.paypal.successCallback = paypalSucccessCallback;
  `;
}

export const PaypalHelper = {
  getOptionalParameters,
  getCallbacksParams,
  getResultCallbacksTemplate,
  getCallbacksTemplate
};


// WEBPACK FOOTER //
// ./src/helpers/PaypalHelper.js